export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8575.55b06e5e.jpg";